// constants.js

// Internal shared storage
const _constants = {};

// Set value
export function set(key, value) {
    _constants[key] = value;
}

// Get value
export function get(key) {
    return _constants[key];
}

// Check if key exists
export function has(key) {
    return Object.prototype.hasOwnProperty.call(_constants, key);
}

// Remove key
export function remove(key) {
    delete _constants[key];
}

// Export the store (protected from overwriting)
const constants = {};
Object.defineProperty(constants, 'all', {
    get() {
        return _constants;
    }
});

export default constants;
